enum TournamentFormat {
    swiss = 'swiss',
    allround = 'allround',
    circelBoule = 'circelBoule',
}

export default TournamentFormat;